import { apiClient, buildQueryString } from '@/services/utils';

export default {
  getAll(params) {
    const queryString = buildQueryString(params)

    return apiClient.get(`/outfits/all${queryString}`);
  },

  create(outfitId, capsuleId, title, productIds) {
    const params = {
      outfit: {
        outfit_id: outfitId,
        capsule_id: capsuleId,
        title: title,
        product_ids: productIds
      }
    }

    return apiClient.post(`/outfits`, params)
  },

  update(outfitId, title) {
    const params = {
      outfit: {
        title: title
      }
    }
    return apiClient.put(`/outfits/${outfitId}`, params)
  },

  destroy(outfitId) {
    return apiClient.delete(`/outfits/${outfitId}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/OutfitService.js